import { render, staticRenderFns } from "./screenshotPC.vue?vue&type=template&id=3a76fc27&"
import script from "./screenshotPC.vue?vue&type=script&lang=js&"
export * from "./screenshotPC.vue?vue&type=script&lang=js&"
import style0 from "./screenshotPC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports